import { call, put, select } from 'redux-saga/effects';
import {
  ContentLibraryOpenedFile,
  ContentLibraryOpenedWhiteboard,
} from 'features/content-library/types';
import {
  selectContentLibraryActiveWhiteboards,
  selectPreviewedFile,
} from 'features/content-library/contentLibrarySlice';
import { bulkWhiteboardsClosed } from 'features/layout/features/content/actions';
import { gridPanelTabClosed } from 'features/layout/features/content/contentSlice';
import { clearLockedContentSaga } from 'features/layout/features/content/sagas/clearLockedContentSaga';
import { board } from 'utils/whiteboard/BoardStateManager';

export function* bulkWhiteboardsClosedSaga(ids: string[]) {
  yield put(bulkWhiteboardsClosed(ids));

  yield call(clearLockedContentSaga, { type: 'whiteboard', ids });

  const whiteboards: ContentLibraryOpenedWhiteboard[] = yield select(
    selectContentLibraryActiveWhiteboards
  );

  if (whiteboards.length === 0) {
    const previewedFile: ContentLibraryOpenedFile | null = yield select(selectPreviewedFile);

    if (!previewedFile) {
      yield call(board.reset);
    }

    yield put(gridPanelTabClosed('whiteboard'));
  }
}
